export type SchedType = "income" | "expense" | "transfer";
export type Frequency = "once" | "weekly" | "biweekly" | "semimonthly" | "monthly" | "bimonthly" | "quarterly" | "yearly" | "installments";
export type Recurrence = Exclude<Frequency, "once" | "installments">;

export interface Occurrence {
  schedule_id: string;
  date: string;
  occurrence_date: string | null;
  frequency: Frequency | null;
  paid: boolean;
  is_oldest: boolean;
  pending_date: string | null;
  paid_on?: string;
  changed: boolean;
  transaction_id?: string;
  source_account_id: string | null;
  destination_account_id: string | null;
  type: SchedType;
  description: string;
  amount: number;
  label: string;
  is_next: boolean;
  overdue: boolean;
  account_name: string;
  category_name?: string | null;
}

export interface Schedule {
  id: string;
  type: SchedType;
  description: string;
  amount: number;
  source_account_id: string | null;
  destination_account_id: string | null;
  category_id: string | null;
  budget_item_id: string | null;
  frequency: Frequency;
  semi_days?: number[] | null;
  next_due_date: string;
  installments_total: number | null;
  installments_paid: number;
}

export interface CardPayment { account_id: string; name: string; statement_date: string; due_date: string; statement_debt: number; remaining: number }

export interface ScheduledResponse {
  month: string;
  today: string;
  occurrences: Occurrence[];
  summary: { to_receive: number; to_pay: number; main_account: { id: string; name: string; balance: number; after: number } | null };
  card_payments: CardPayment[];
  biggest: Occurrence[];
  schedules: Schedule[];
}

export const RECURRENCE_LABELS: Record<Recurrence, string> = {
  weekly: "Semanal", semimonthly: "Quincenal", biweekly: "Cada 2 semanas (catorcenal)", monthly: "Mensual", bimonthly: "Bimestral", quarterly: "Trimestral", yearly: "Anual",
};
export const SEMI_PRESETS: { value: string; label: string; days: [number, number] }[] = [
  { value: "15-31", label: "15 y último del mes", days: [15, 31] }, { value: "1-15", label: "1 y 15", days: [1, 15] }, { value: "1-16", label: "1 y 16", days: [1, 16] },
];
